import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import classNames from 'classnames';

import { Button, TextField, FormikFastField } from '@ets-global/b2c-website-ui';
import InjectHtml from '../../../../InjectHtml';
import useYup from '../../../../../hooks/useYup';
import useDataLayer from '../../../../../hooks/useDataLayer';
import { SCORING_DOCUMENT_TYPE } from '../../../../../constants';

import './styles.scss';

const SendDigitalDocumentByEmail = ({ onSubmitDigitalDocumentByEmail = () => {}, documentType }) => {
  const { t } = useTranslation();
  const { Yup } = useYup();
  const { pushEventOpenSharingBoxDigitalScoreReport, pushEventShareDigitalScoreReport } = useDataLayer();
  const [isOpened, setIsOpened] = useState(false);

  const translationPrefix =
    documentType === SCORING_DOCUMENT_TYPE.DIGITAL_SCORE_REPORT
      ? 'send-digital-score-report'
      : 'send-proof-of-completion';

  useEffect(() => {
    if (isOpened) {
      pushEventOpenSharingBoxDigitalScoreReport();
    }
  }, [isOpened]);

  const toggle = () => {
    setIsOpened(!isOpened);
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required().email(),
  });

  const onSubmit = (...args) =>
    onSubmitDigitalDocumentByEmail(...args).finally(() => {
      pushEventShareDigitalScoreReport();
      toggle();
    });

  return (
    <div className="send-digital-document-by-email">
      <div className="send-digital-document-by-email__heading" onClick={toggle} aria-hidden={'true'}>
        <InjectHtml
          component={'p'}
          className="send-digital-document-by-email__description"
          html={t(`account.sessions.candidate.${translationPrefix}-by-email.description`)}
        />
        <i
          className={classNames(
            'send-digital-document-by-email__dropdown',
            isOpened
              ? 'send-digital-document-by-email__dropdown--up'
              : 'send-digital-document-by-email__dropdown--down',
          )}
        />
      </div>
      {isOpened && (
        <Formik onSubmit={onSubmit} initialValues={{ email: '' }} validationSchema={validationSchema}>
          <Form className="send-digital-document-by-email__form">
            <FormikFastField
              id="email"
              name="email"
              type="email"
              component={TextField}
              label={t(`account.sessions.candidate.${translationPrefix}-by-email.input-label`)}
              required={true}
              className="send-digital-document-by-email__input"
            />
            <Button
              type="submit"
              className="button button--transparent-light send-digital-document-by-email__button"
              aria-label={`${t(`account.sessions.candidate.${translationPrefix}-by-email.button`)} button`}
            >
              {t(`account.sessions.candidate.${translationPrefix}-by-email.button`)}
            </Button>
          </Form>
        </Formik>
      )}
    </div>
  );
};

SendDigitalDocumentByEmail.propsTypes = {
  onSubmitDigitalDocumentByEmail: PropTypes.func.isRequired,
  documentType: PropTypes.string.isRequired,
};

export default SendDigitalDocumentByEmail;
